import React from "react";
import PropTypes from "prop-types";
import ReactGaugeChart from "react-gauge-chart";

const GaugeChart = ({ percent }) => (
  <ReactGaugeChart
    id="gauge-chart"
    textColor="#333"
    nrOfLevels={3}
    arcsLength={[0.8, 0.8, 0.8]}
    colors={["#84D3F5", "#4FB2EC", "#3379C0"]}
    percent={percent}
    arcPadding={0.02}
    text
    animate={false}
  />
);
GaugeChart.propTypes = {
  percent: PropTypes.number.isRequired
};
export default GaugeChart;
